













import { Component, Vue, Prop } from "vue-property-decorator";
import TaskType from "../../entities/task-type";

@Component({})
export default class SelectTaskType extends Vue {
  @Prop({ required: true }) value!: TaskType[];
  @Prop({ default: () => [] }) options!: TaskType[];

  input(value: TaskType[]) {
    this.$emit("input", value);
  }
}
